import { useTranslation } from 'react-i18next';
import { useDateFormat } from '@/utils/dates';
import { BannerBar, BannerCta } from './GraceBanner.styled';

interface GraceBannerProps {
  graceEndsAt: string | null;
}

export default function GraceBanner({ graceEndsAt }: GraceBannerProps) {
  const { t } = useTranslation();
  const { formatDate } = useDateFormat();

  const message = graceEndsAt
    ? t('billing.access.graceMessage', { date: formatDate(graceEndsAt) })
    : t('billing.access.graceMessageNoDate');

  return (
    <BannerBar role="alert">
      <span>{message}</span>
      <BannerCta to="/settings">{t('billing.access.graceCta')}</BannerCta>
    </BannerBar>
  );
}
